const CATEGORY_LINKS = [
  {
    slug: 'trend-spark',
    path: '/trend-spark/',
    title: '01区 Trend Spark',
    subtitle: 'インスピレーションを刺激する、最新のトレンド情報',
    modifier: '--trend-spark',
  },
  {
    slug: 'mens-skin-metrics',
    path: '/mens-skin-metrics/',
    title: "02区 Men's Skin Metrics",
    subtitle: '男性の肌・美容に関する知識を、基礎から最先端まで発信',
    modifier: '--mens-skin-metrics',
  },
  {
    slug: 'derma-science',
    path: '/derma-science/',
    title: '03区 Derma Science',
    subtitle: '皮膚科学を学び、正しい選択眼を身に付ける',
    modifier: '--derma-science',
  },
  {
    slug: 'color-gallery',
    path: '/color-gallery/',
    title: '04区 Color Gallery',
    subtitle: '美とアートが交差する、ユニークな情報体験',
    modifier: '--color-gallery',
  },
  {
    slug: 'borderless-beauty',
    path: '/borderless-beauty/',
    title: '05区 Borderless Beauty',
    subtitle: '先入観に囚われない、自由な選択肢や価値観を提案',
    modifier: '--borderless-beauty',
  },
  {
    slug: 'wellness-lab',
    path: '/wellness-lab/',
    title: '06区 Wellness Lab',
    subtitle: '心と身体を整え、健やかな美しさに導くメソッドを発信',
    modifier: '--wellness-lab',
  },
  {
    slug: 'sustainability',
    path: '/sustainability/',
    title: '07区 Sustainability',
    subtitle: '環境配慮や社会貢献の取り組みを紹介',
    modifier: '--sustainability',
  },
];

function normalizePath(path) {
  if (!path) return '/';

  const raw = String(path).trim();
  if (!raw) return '/';

  // クエリとハッシュは同一判定から除外
  const stripped = raw.split('#')[0].split('?')[0];

  let pathname = stripped;
  try {
    pathname = new URL(stripped, window.location.origin).pathname;
  } catch (_) {
    pathname = stripped;
  }

  const withSlash = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const noTrailingSlash = withSlash.replace(/\/+$/, '') || '/';
  const noIndexHtml = noTrailingSlash.replace(/\/index\.html$/i, '') || '/';
  return noIndexHtml;
}

function getArrowSvg() {
  return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.17 10L14.83 10M14.83 10L10.83 14M14.83 10L10.83 6" stroke="#45433E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
}

export function getCategoryLinksMarkup({
  basePath = '/kaiho-biku',
  currentPath,
  hideCurrent = true,
} = {}) {
  const siteBase = basePath.replace(/\/$/, '');
  const current = normalizePath(currentPath || window.location.href);

  const links = CATEGORY_LINKS.map((category) => {
    const href = `${siteBase}${category.path}`;
    const isCurrent = current === normalizePath(href);

    if (hideCurrent && isCurrent) {
      return '';
    }

    return `
      <a href="${href}" class="menu-panel__category-link ${category.modifier}"${isCurrent ? ' hidden aria-hidden="true" tabindex="-1"' : ''}>
        <span>${category.title}<br><span>${category.subtitle}</span></span>
        ${getArrowSvg()}
      </a>
    `;
  }).join('');

  return `
    <nav class="l-catetop-links">
      <h2 class="l-catetop-h2">他の区を見る</h2>
      <div class="l-catetop-links-list">
        ${links}
      </div>
    </nav>
  `;
}
